export default __webpack_public_path__ + "static/media/tiffi1big_thumb.03433ff9.jpg";